import { Button } from '@mui/material';
import * as React from 'react';

interface Props {
  onClose: () => void;
}

export const Success: React.FC<Props> = (props) => {
  return (
    <div className="flex flex-col items-center">
      <div className="text-center space-y-4 pt-16 pb-32">
        <span className="text-6xl font-bold">📧</span>
        <h1 className="font-medium">Your Per Diem Report is on the way!</h1>
        <p>
          Please allow a <b>few minutes</b> for the report to reach your email
        </p>
      </div>
      <div className="self-end">
        <Button
          onClick={props.onClose}
          variant="outlined"
          color="info"
          size="large"
          className="px-8"
        >
          Close
        </Button>
      </div>
    </div>
  );
};
Success.displayName = 'SmartPerDiem.DownloadModal.Success';
